module.exports = __webpack_public_path__ + "img/knu2_thumbnail.b5e21b97.jpg";